import React from "react";
import Buycoin from "../../component/buycoin/index";

export function Buycoins() {
  return <Buycoin />;
}
